import React from 'react';

import Accordion from 'react-bootstrap/Accordion';

import UserItem from './UserItem';

class UserAccordion extends React.Component {
    render() {
	const users = this.props.users;
	
	return (
	    <Accordion flush>
		{users.map(user => (
		    <UserItem user={user} key={user.id} />
		))}
	    </Accordion>
	);
    }
}

export default UserAccordion;
